import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@services";
import type { ChallengeAddOn } from "@models";
import { getAddOnTitle } from "@utils";

@Pipe({
  name: "addOnTitle",
  standalone: true,
  pure: false,
})
export class AddOnTitlePipe implements PipeTransform {
  constructor(private _translateService: TranslateService) {}

  public transform(
    addOn: ChallengeAddOn,
    key: "actions" | "feeInfo" | "fullTitle",
    currencyType: string | undefined = "",
  ): string {
    const addOnTitle: { actions: string; feeInfo: string; fullTitle: string } = getAddOnTitle(
      addOn,
      this._translateService,
      currencyType,
    );

    if (!addOnTitle[key]) {
      throw new Error(
        `Invalid key "${key}" provided to addOnTitle pipe. Valid keys are: actions, feeInfo, fullTitle.`,
      );
    }

    if (addOnTitle.feeInfo === "free") {
      addOnTitle.feeInfo = this._translateService.getTranslation("app.dashboard.addOn.free");
    }

    return addOnTitle[key];
  }
}
